/* eslint-disable */
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const { REACT_APP_AUTH0_AUDIENCE } = process.env;

const getAccessToken = ({
  audience = REACT_APP_AUTH0_AUDIENCE,
  scope,
} = {}) => {
  const {
    getAccessTokenSilently,
    getAccessTokenWithPopup,
    isLoading,
  } = useAuth0();
  const [state, setState] = useState({});

  const get = async ({ audience, scope }) => {
    let accessToken;
    try {
      accessToken = await getAccessTokenSilently({ audience, scope });
    } catch (error) {
      if (error.error === "consent_required") {
        accessToken = await getAccessTokenWithPopup({ audience, scope });
      } else {
        throw error;
      }
    }
    return accessToken;
  };

  useEffect(() => {
    if (isLoading) return;

    let cancelled = false;

    const refresh = async () => {
      try {
        const accessToken = await get({ audience, scope });
        if (cancelled) return;
        setState({
          value: accessToken || null,
          error: undefined,
        });
      } catch (error) {
        if (cancelled) return;
        setState((prev) => ({
          ...prev,
          value: prev.value || null,
          error,
        }));
      }
    };

    refresh();

    // Bug real (auditoría 2026-08-14): el token se pedía UNA sola vez al
    // terminar de cargar Auth0 y nunca más — en una sesión larga (Agenda,
    // Monitor abiertos todo el día) el token expiraba y todos los
    // requests siguientes fallaban con 401 sin ningún mecanismo de
    // recuperación. getAccessTokenSilently ya cachea internamente (no
    // pega a la red si el token vigente todavía sirve), así que llamarlo
    // periódicamente es barato y deja que el SDK lo renueve antes de que
    // expire.
    const interval = setInterval(refresh, 5 * 60 * 1000);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [isLoading]);

  return state;
};

export default getAccessToken;
/* eslint-enable */
